import { User } from '@/type';
import api from '@/API';
import { prepareKeyword, matchesUser } from './user-search';

export const status: {[key: string]: number} = {
  INACTIVE: 0,
  ACTIVE: 1,
  INVITED: 2,
};

export function isInactive(value: number) {
  return (value === status.INACTIVE);
}

export function isActive(value: number): boolean {
  return (value === status.ACTIVE);
}

export function isInvited(value: number) {
  return (value === status.INVITED);
}

export function invite(
  accountId: number, firstName: string, lastName: string, email: string, roleId: number,
): Promise<User> {
  return api
    .post(`accounts/${accountId}/users`, {
      firstName,
      lastName,
      email,
      roleId,
    })
    .then(response => response.data);
}

export function resendInvite(userId: number): Promise<void> {
  return api.put(`users/${userId}/invite`);
}

export function generateInvitationLink(userId: number): Promise<{ url: string }> {
  return api.post(`users/${userId}/invitation-link`).then(response => response.data);
}

export function acceptInvite(token: string, password: string): Promise<void> {
  return api.put('accept-invitation', { token, password });
}

export function edit(user: User): Promise<void> {
  return api.put(`users/${user.id}`, {
    firstName: user.firstName,
    lastName: user.lastName,
    roleId: user.role.id,
  });
}

export function deleteUser(id: number): Promise<void> {
  return api.delete(`users/${id}`);
}

export function changePassword(
  userId: number,
  currentPassword: string,
  newPassword: string,
): Promise<void> {
  return api.put(`users/${userId}/password`, { currentPassword, newPassword });
}

export function recoverPassword(email: string): Promise<void> {
  return api.put('recover-password', { email });
}

export function resetPassword(token: string, password: string): Promise<void> {
  return api.put('reset-password', { token, password });
}

export function disableSetupReminders(userId: number): Promise<User> {
  return api.put(`users/${userId}/setup-reminders/disable`).then(response => response.data);
}

export function enableSetupReminders(userId: number): Promise<User> {
  return api.put(`users/${userId}/setup-reminders/enable`).then(response => response.data);
}

export function filter(keyword: string|null, users: User[]): User[] {
  const kw = prepareKeyword(keyword);
  if (kw.raw === '') return users;
  return users.filter(u => matchesUser(u, kw));
}
